export default __webpack_public_path__ + "static/media/Kasturba.22f88164.png";